import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Thumbnail from "../../../lib/Thumbnail"
import CDN from "../../../lib/CDN"
import If from "../../common/control/If"
import { DEFAULT } from '../../../constants/design/SkinTypes'

class SkinCardPreview extends Component {
	render() {
		const { skin, type, currentSkin, onClick } = this.props

		const isDefault = type === DEFAULT
		const isCurrent = skin.skinName === currentSkin.name

		return (
			<a className="empty_thumb" onClick={(e) => onClick(skin)} href="#">
				<If condition={isDefault}>
					<img src={ CDN.getSkinUrl('/0/'+skin.skinName+'/preview560.jpg')  } width="280" height="210" className="thumb_img" alt="" />
				</If>
				<If condition={!isDefault}>
					<img src={ Thumbnail.make('C280x210', skin.preview)  } width="280" height="210" className="thumb_img" alt="" />
				</If>

				<If condition={isDefault && isCurrent}>
					<span className="txt_status">
						<span className="screen_out">현재상태 : </span>
						사용중
					</span>
				</If>
			</a>
		)
	}
}

SkinCardPreview.propTypes = {
	skin: PropTypes.object.isRequired,
	currentSkin: PropTypes.object.isRequired,
	type: PropTypes.string.isRequired,
	onClick: PropTypes.func.isRequired
}

export default SkinCardPreview
